
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/components/draw-countdown",
      function () {
        return require("private-next-pages/design-system/components/draw-countdown.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/components/draw-countdown"])
      });
    }
  